'use client';

import { Contact } from '@/components/contact';
import { CaseStudiesBlock } from '@/features/services/blocks/case-studies/case-studies-block';
import { HeroBlock } from '@/features/services/blocks/hero/hero-block';
import UiUxDesignSection from '@/features/services/blocks/ui-ux-design/ui-ux-design-block';
import { MainLayout } from '@/layouts/main';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
import type { FC } from 'react';

type ServicesPageClientProps = {
  locale: string;
};

export const ServicesPage: FC<ServicesPageClientProps> = ({ locale }) => {
  return (
    <>
      <Head>{generateNextSeo({
        title: `Services - ${locale}`,
        description: `Our services - ${locale}`
      })}</Head>
      <MainLayout>
        <div className="bg-[#0A0A0A] relative">
          <HeroBlock />
          <CaseStudiesBlock />
          <UiUxDesignSection />
          <Contact />
        </div>
      </MainLayout>
    </>
  );
};
